import Select from 'react-select'
import * as React from 'react'
import * as moment from 'moment'
import DashboardItem from './DashboardItem'
import { IRecentTripObj, ILastActiveTripsByStages, ITripFilters, IRiderTrip, IPagination } from '../../types'
import history from '../../history'
import ReactPagination from '../ui/ReactTablePagination'

interface IControlsProps {
  filters: ITripFilters
  onChange: (filters: ITripFilters) => Promise<any>
}
interface IControlsState {}

const options = [
  { label: 'All Active', value: 'ACTIVE' },
  { label: 'Scheduled today', value: 'SCHEDULED' },
  { label: 'Requesting', value: 'REQUESTED' },
  { label: 'Waiting', value: 'WAITING' },
  { label: 'Driving to pickup', value: 'DRIVING_TO_PICK_UP' },
  { label: 'Waiting for pickup', value: 'ACCEPTED' },
  { label: 'En Route', value: 'PICKED_UP' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Manually completed', value: 'MANUALLY_COMPLETED' },
  { label: 'Cancelled', value: 'CANCELLED' }
]

class TripDashControls extends React.Component<IControlsProps, IControlsState> {
  public render() {
    const filters = this.props.filters
    const selectedOption = options.find(o => o.value === (filters.status || [])[0]) || options[0]
    const styles = {
      control: (provided: any, state: any) => {
        return {
          cursor: 'pointer',
          display: 'flex',
          minHeight: '38px',
          borderWidth: '1px',
          borderBottom: '1px solid',
          borderColor: '#137CBD'
        }
      },
      singleValue: (provided: any, state: any) => ({
        ...provided,
        color: '#137CBD'
      }),
      dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        color: '#137CBD'
      }),
      indicatorSeparator: (provided: any, state: any) => ({
        width: 0
      })
    }
    return (
      <div className='select-control-container mb1 custom-select' style={{ width: '130px' }}>
        {/* <Select
          styles={styles}
          classNamePrefix='select-control'
          isSearchable={false}
          options={options}
          value={selectedOption}
          onChange={this.changeStatus}
        /> */}
      </div>
    )
  }

  private changeStatus = (option: any) => {
    if (option) {
      const status = ['ACTIVE', 'SCHEDULED'].includes(option.value) ? undefined : [option.value]
      let statusGroup

      if (option.value === 'ACTIVE') {
        statusGroup = 'active'
      }

      if (option.value === 'SCHEDULED') {
        statusGroup = 'scheduled'
      }

      this.props.onChange({ status, statusGroup })
    }
  }
}

interface ITripsDashboardProps {
  orgId: string
  currentUserId: string
  showOrgServiceArea: () => void
  updateTripFilters: (filters: ITripFilters) => Promise<any>
  fetchTrips: (filters: ITripFilters, currentUserId: string) => Promise<any>
  cloneTrip: (trip: IRiderTrip) => Promise<any>
  trips: IRecentTripObj
  tripFilters: ITripFilters
  isFetching: boolean
}

interface ITripsDashboardState {
  pageIndex: number
  pages: number
}

const PAGE_SIZE = 50
const INTERVAL = 20000

class StationUserTripsDashboard extends React.Component<ITripsDashboardProps, ITripsDashboardState> {
  public intervalId: any
  public resetTripFilter: boolean

  public state = {
    pageIndex: 0,
    pages: 1
  }

  public async componentDidMount() {
    this.getData()
    this.intervalId = setInterval(this.getData, INTERVAL)
    this.resetTripFilter = true
  }

  public componentWillMount() {
    this.props.showOrgServiceArea()
  }

  public async componentWillUnmount() {
    clearInterval(this.intervalId)
    if (this.resetTripFilter) {
      await this.props.updateTripFilters({
        orgId: this.props.orgId,
        productIds: undefined,
        status: undefined,
        statusGroup: undefined,
        timeField: undefined,
        timeStart: undefined,
        timeEnd: undefined,
        sortBy: []
      })
    }
  }

  public async componentDidUpdate(prevProps: ITripsDashboardProps) {
    const { tripFilters } = this.props
    if (JSON.stringify(prevProps.tripFilters) !== JSON.stringify(tripFilters)) {
      this.getData()
    }
    if (this.props.orgId !== prevProps.orgId) {
      this.props.updateTripFilters({
        orgId: this.props.orgId
      })
    }
  }

  public render() {
    const { tripFilters } = this.props
    const { pageIndex, pages } = this.state
    const canNext = pages > 1 && pageIndex + 1 < pages
    const canPrevious = pages > 1 && pageIndex + 1 > 1
    if (this.props.trips === undefined || !Object.keys(this.props.trips).length) {
      return (
        <div className='pt1 pb2 px3'>
          <TripDashControls filters={tripFilters} onChange={this.props.updateTripFilters} />
          <div className='center'>
            <p className=''>No Trips</p>
          </div>
        </div>
      )
    }
    const trips = this.props.trips !== undefined ? Object.values(this.props.trips) : null
    return (
      <React.Fragment>
        <div className='pt1 pb2 px1' style={{ height: 'calc(100% - 8rem)', overflowY: 'scroll' }}>
          {/* <div className='pt1 pb2 px1' style={{ height: 'calc(100% - 12rem)', overflowY: 'scroll'}}> */}
          <TripDashControls filters={tripFilters} onChange={this.props.updateTripFilters} />
          <div className='col-12 m0'>
            {trips &&
              trips
                .filter((item: IRecentTripObj) => !!item)
                .map((item: IRecentTripObj) => {
                  return <DashboardItem key={item.id} trip={item} cloneTrip={this.copyTrip(item)} />
                })}
          </div>
        </div>
      </React.Fragment>
    )
  }

  private getData = async () => {
    if (!this.props.currentUserId) {
      return
    }
    const { tripFilters } = this.props
    const filters =
      !tripFilters.status && !tripFilters.statusGroup ? { ...tripFilters, statusGroup: 'active' } : tripFilters

    if (filters.statusGroup === 'active') {
      filters.timeField = 'tripCreated'
      filters.sortBy = ['created-desc']
      filters.timeStart = moment()
        .subtract(72, 'hours')
        .toISOString()
      filters.timeEnd = moment().toISOString()
    } else if (filters.statusGroup === 'scheduled') {
      filters.timeField = 'pickup'
      filters.timeStart = moment()
        .subtract(8, 'hours')
        .toISOString()
      filters.timeEnd = moment()
        .add(8, 'hours')
        .toISOString()
      filters.sortBy = ['scheduledPickupTime-asc']
    } else {
      filters.timeField = undefined
      filters.timeStart = undefined
      filters.timeEnd = undefined
      filters.sortBy = ['created-desc']
    }

    const total = await this.props.fetchTrips(filters, this.props.currentUserId)
    this.setState({
      pages: Math.ceil(total / PAGE_SIZE)
    })
  }

  private copyTrip = (trip: IRecentTripObj) => (e: any) => {
    history.push(`/trips/create/${trip.rider.riderId}`)
    this.props.cloneTrip(trip)
  }

  private viewMoreTrips = () => {
    const { tripFilters } = this.props
    const filters =
      !tripFilters.status && !tripFilters.statusGroup ? { ...tripFilters, statusGroup: 'active' } : tripFilters
    this.props.updateTripFilters(filters)
    this.resetTripFilter = false
    history.push('/trips-management')
  }

  private nextPage = () => {
    const pageIndex = this.state.pageIndex + 1
    const pagination = { skip: pageIndex * PAGE_SIZE, take: PAGE_SIZE }
    this.props.fetchTrips(this.props.tripFilters, this.props.currentUserId)
    this.setState({
      pageIndex
    })
  }

  private previousPage = () => {
    const pageIndex = this.state.pageIndex - 1
    const pagination = { skip: pageIndex * PAGE_SIZE, take: PAGE_SIZE }
    this.props.fetchTrips(this.props.tripFilters, this.props.currentUserId)
    this.setState({
      pageIndex
    })
  }
}

export default StationUserTripsDashboard



// WEBPACK FOOTER //
// ./src/components/station-user-trips/StationUserTripDashboard.tsx